export default {
    getProfiles() {
        return '/api/profiles';
    },
    getCatchImages(ownerId) {
        return `/api/catches/${ownerId}/images`;
    },
    getCatcherImages(ownerId) {
        return `/api/catchers/${ownerId}/images`;
    },
    getRegionImages(ownerId) {
        return `/api/regions/${ownerId}/images`;
    },
    getCatchesByRegion(region) {
        return `/api/catches?region=${region}`;
    },
    getCatchesByQuery(queries) {
        return `/api/catches?${queries.join('&')}`;
    },
    getCatch(id) {
        return `/api/catches/${id}`;
    },
    getCatches() {
        return '/api/catches';
    },
    getRecordsByRegion(region) {
        return `/api/records?region=${region}`;
    },
    getRecordsByQuery(queries) {
        return `/api/records?${queries.join('&')}`;
    },
    getRecordsByCatcherId(catcherId) {
        return `/api/records?catcher=${catcherId}&region=258`;
    },
    getRegions() {
        return '/api/regions';
    },
    getRegionsByLocation(gps) {
        return `${this.getRegions()}?location=${gps}`;
    },
    getRegion(id) {
        return `${this.getRegions()}/${id}`;
    },
    getRegionParent(id) {
        return `/api/regions/${id}/parent`;
    },
    getRegionChildren(id) {
        return `${this.getRegion(id)}/children`;
    },
    getRegionDescendants(id) {
        return `${this.getRegion(id)}/descendants`;
    },
    getSpecies() {
        return '/api/species?lang=no-bm';
    },
    getSpeciesByRegion(region) {
        return `/api/regions/${region}/species?lang=no-bm`;
    },
    getCatcher(catcherId) {
        return `/api/catchers/${catcherId}`;
    },
    getCatchers() {
        return '/api/catchers';
    },
};
